import React from 'react'

import { Box, TableRow, TextField, Typography } from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'

import { Select } from 'components'
import { Table, TableBody, TableCell, TableHead } from 'components/Table'

import useIncidentManegement from 'hooks/useIncidentManegement'

import useStyles from './styles'

const ScaleTable = () => {
  const classes = useStyles()

  const { isShow = false, incident } = useIncidentManegement()
  const { control, errors, watch } = useFormContext()

  const largeScale = incident?.highRisk?.largeScale
  const formValues = watch()

  return (
    <Box className={classes.tableContainer}>
      <Table size="small" noWrap>
        <TableHead className={classes.tableHeader}>
          <TableRow>
            <TableCell align="center" width="30%">
              Processo de tratamento
            </TableCell>
            <TableCell align="center" width="30%">
              Faixas de classificação
            </TableCell>
            <TableCell align="center" width="30%">
              Valores do tratamento
            </TableCell>
            <TableCell align="center" width="10%">
              Valor Atribuído
            </TableCell>
          </TableRow>
        </TableHead>
        {largeScale?.map((largeScaleItem, index) => (
          <TableBody key={largeScaleItem?.id}>
            <TableRow>
              <TableCell align="center" className={classes.tableCellText}>
                <Box>
                  <Typography variant="subtitle2">
                    {largeScaleItem?.content}
                  </Typography>
                </Box>
              </TableCell>
              <TableCell className={classes.tableCellText}>
                <Controller
                  control={control}
                  name={`answers[${index}].range`}
                  defaultValue={
                    largeScaleItem?.answer?.classificationRange || ''
                  }
                  as={
                    <Select
                      noWrap={true}
                      items={largeScaleItem?.classificationRanges}
                      fieldName="name"
                      fieldValue="id"
                      disabled={isShow}
                      error={!!errors?.answers?.[index]?.range}
                      helperText={errors?.answers?.[index]?.range?.message}
                      FormHelperTextProps={{
                        style: {
                          whiteSpace: 'normal',
                          overflowWrap: 'anywhere',
                        },
                      }}
                    />
                  }
                />
              </TableCell>
              <TableCell align="center" className={classes.tableCellText}>
                {index < 3 ? (
                  <Controller
                    control={control}
                    name={`answers[${index}].answer`}
                    defaultValue={largeScaleItem?.answer?.answer || ''}
                    as={
                      <TextField
                        fullWidth
                        className={classes.textFieldFull}
                        inputProps={{
                          style: { textAlign: 'center' },
                        }}
                        disabled={isShow}
                        error={!!errors?.answers?.[index]?.answer}
                        helperText={errors?.answers?.[index]?.answer?.message}
                        FormHelperTextProps={{
                          style: {
                            whiteSpace: 'normal',
                            overflowWrap: 'anywhere',
                          },
                        }}
                      />
                    }
                  />
                ) : (
                  <TextField
                    disabled={true}
                    value={
                      largeScaleItem?.classificationRanges?.find(
                        (range) =>
                          range.id === formValues[`answers[${index}].range`],
                      )?.name ||
                      largeScaleItem?.answer?.answer ||
                      ''
                    }
                    fullWidth
                    className={classes.textFieldFull}
                    inputProps={{
                      style: { textAlign: 'center' },
                    }}
                  />
                )}
              </TableCell>
              <TableCell align="center" className={classes.tableCellText}>
                <TextField
                  disabled={true}
                  value={
                    largeScaleItem?.classificationRanges?.find(
                      (range) =>
                        range.id === formValues[`answers[${index}].range`],
                    )?.assignedValue ||
                    largeScaleItem?.answer?.assignedValue ||
                    ''
                  }
                  fullWidth
                  className={classes.textFieldFull}
                  inputProps={{
                    style: { textAlign: 'center' },
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        ))}
      </Table>
    </Box>
  )
}

export default ScaleTable
